import { Link } from "react-router-dom";
import "./component.css";

const Component = () => {
  return (
    <>
    <div className="sec1tion2">
            
      <div className="container ">
        <div className="row feature-top02">
          <div className="col-lg-6">
          <center><img src="img/resources.png" className="img-fluid feature-img2"/></center>
          </div>
          <div className="col-lg-6"> 

          <div className="feature-padd2">
         <p className="deskbox-txt2">Resources Management & Mapping</p>
         <p className="deskbox-descri">Maximize the potential of your coworking space with our Resources Management module.</p>
         <div class="desk-top-2">
                   <div className="deskbox-feature1-flx">
            <div className="flx2">
            <i className="ri-check-line feature-icn"></i>
            </div>
            <div className="flx3">
                <p className="feature-txt1">Seats & Cabins Mapping</p>
                <p className="feature1-txt2">Effortlessly assign seats and cabins to your clients quickly and accurately.</p>
            </div>
         </div>
         <div className="deskbox-feature1-flx">
            <div className="flx2">
            <i className="ri-check-line feature-icn"></i>
            </div>
            <div className="flx3">
                <p className="feature-txt1">Meeting Room Bookings</p>
                <p className="feature1-txt2">Admins and Members have the option to track & reserve on-demand meeting rooms.</p>
            </div>
         </div>
         <div className="deskbox-feature1-flx">
            <div className="flx2">
            <i className="ri-check-line feature-icn"></i>
            </div>
            <div className="flx3">
                <p className="feature-txt1">Occupancy Analysis</p>
                <p className="feature1-txt2">Access real-time data to monitor occupancy trends and make informed decisions.</p>
            </div>
         </div>
           </div>
           </div>

           </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Component;
